import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
const bind = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const fail = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
  return x => $0(Data$dNonEmpty.$NonEmpty(x, Data$dList$dTypes.Nil));
})();
const Day = x => x;
const showDay = Data$dDate.showDate;
const ordDay = Data$dDate.ordDate;
const newtypeDay_ = {Coercible0: () => {}};
const genericDay_ = {to: x => x, from: x => x};
const eqDay = Data$dDate.eqDate;
const udecodeDay = {
  unsafeDecode: value => {
    const v = DateUtils.parseISODate(Unscramble.decodeString(value));
    if (v.tag === "Just") { return v._1; }
    if (v.tag === "Nothing") { return Unscramble.decodingError("Invalid date"); }
    $runtime.fail();
  }
};
const fromDay = v => v;
const encodeDay = {encode: v => DateUtils.formatISODate(v)};
const decodeDay = {
  decode: value => bind(Foreign$dGeneric$dClass.readString(value))(str => {
    const v = DateUtils.parseISODate(str);
    if (v.tag === "Just") { return pure(v._1); }
    if (v.tag === "Nothing") { return fail(Foreign.$ForeignError("ForeignError", "Invalid date")); }
    $runtime.fail();
  })
};
const dayDate = fromDay;
export {Day, bind, dayDate, decodeDay, encodeDay, eqDay, fail, fromDay, genericDay_, newtypeDay_, ordDay, pure, showDay, udecodeDay};
